module.exports = __webpack_public_path__ + "static/media/log3.5a9d03ec.jpg";